<div>
    <label for="checkbox" class="form-check-label">{{ label }}</label>
    <input type="checkbox" [formControl]="control" [value]="'cribio'"/>
</div>
